/* eslint-disable */
const isNonEmptyString = something => typeof something === 'string' && Boolean(something);

export function getPaypalAccountNameFromPaymentMethod(paymentMethod) {
    if (isNonEmptyString(paymentMethod.payer_email)) {
        return paymentMethod.payer_email;
    }
    if (paymentMethod.meta && isNonEmptyString(paymentMethod.meta.account_name)) {
        return paymentMethod.meta.account_name;
    }
    return undefined;
}

export function isPaypalPaymentMethod(paymentMethod) {
    const accountName = getPaypalAccountNameFromPaymentMethod(paymentMethod);

    return Boolean(accountName);
}

export function isPaypalPaymentMethodReady(response) {
    const { data = {} } = response;
    const { order = {} } = data;
    const { payment_method: paymentMethod } = order;

    return Boolean(
        paymentMethod && isPaypalPaymentMethod(paymentMethod),
    );
}
